import React from 'react';
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../../styles/proposition-bets-widget.module.scss";
import {KeyboardArrowDown} from "../../../../core/icons/keyboard-arrow/keyboard-arrow-down";
import {KeyboardArrowUp} from "../../../../core/icons/keyboard-arrow/keyboard-arrow-up";
import {PROPOSITION_BETS} from "../../proposition-bets-widgets.consts";

export const PropositionBetsWidgetSectionSeeMore = observer(({controller, bet, section, isPreview, onClick, fullDisplay}) => {
  const {state, terms, config} = controller;
  const {game, sportTypeId} = state;
  const {statusGroup} = game;
  const {competitorId} = section;
  const {lineTypeId} = bet;
  const {source} = config;
  const {SEE_MORE, SEE_LESS} = terms;

  const buttonLabel = fullDisplay ? SEE_LESS : SEE_MORE;
  const shouldRenderButton = !isPreview && section?.rows?.length > 2;

  const buttonProps = {
    className: classNames(styles.section_see_more),
    onClick: () => {
      sendEvent();
      onClick(!fullDisplay);
    }
  }

  const sendEvent = () => controller.action(PROPOSITION_BETS.ANALYTICS.ACTION_TYPES.onShowMoreClick, {
    gameId: game.id,
    status: statusGroup,
    marketType: lineTypeId,
    clickType: !fullDisplay ? PROPOSITION_BETS.ANALYTICS.CLICK_TYPE.open : PROPOSITION_BETS.ANALYTICS.CLICK_TYPE.close,
    competitorId,
    sportTypeId,
    source,
  })

  return (
    shouldRenderButton ? <div {...buttonProps}>
      {buttonLabel}
      {
        fullDisplay ? <KeyboardArrowUp className={classNames(styles.arrow)}/> : <KeyboardArrowDown className={classNames(styles.arrow)}/>
      }
    </div> : null
  )
});
